import { render } from "./PowerSearch.vue?vue&type=template&id=455b7511"
import script from "./PowerSearch.vue?vue&type=script&lang=js"
export * from "./PowerSearch.vue?vue&type=script&lang=js"

import "./PowerSearch.vue?vue&type=style&index=0&id=455b7511&lang=css"

import exportComponent from "/sv-shops-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__